const config = {
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  ALGOLIA_APP_ID: import.meta.env.VITE_ALGOLIA_APP_ID as string,
  ALGOLIA_API_KEY: import.meta.env.VITE_ALGOLIA_API_KEY as string,
  APP_DOMAIN: import.meta.env.VITE_APP_DOMAIN as string,
  INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,
  LOGROCKET_PROJECT_KEY: import.meta.env.VITE_LOGROCKET_PROJECT_KEY,
  MIX_PANEL_PROJECT_TOKEN: import.meta.env.VITE_MIX_PANEL_PROJECT_TOKEN,
  GROWTHBOOK_CLIENT_CODE: import.meta.env.VITE_GROWTHBOOK_CLIENT_CODE,
  GIT_COMMIT_SHA: import.meta.env.VITE_GIT_COMMIT_SHA,
  APP_ROOT: import.meta.env.VITE_APP_ROOT,
  DATADOG_CLIENT_TOKEN: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  STRIPE_ENVIRONMENT_ID: import.meta.env.VITE_STRIPE_ENVIRONMENT_ID,
  TRUSTPILOT_TEMPLATE_ID: import.meta.env.VITE_TRUSTPILOT_TEMPLATE_ID,
  TRUSTPILOT_BUSINESSUNIT_ID: import.meta.env.VITE_TRUSTPILOT_BUSINESSUNIT_ID,
  TRUSTPILOT_TOKEN: import.meta.env.VITE_TRUSTPILOT_TOKEN,
};

window.gitCommitHash = config.GIT_COMMIT_SHA;

export default config;
